import fetchJSON from '../fetchJSON'

export const defaultState = {
  watchLater: []
}

export interface WatchLaterItem {
  id: number
  channel: {
    id: number
  }
}

export type WatchLaterResponse =  {
  watchLater: WatchLaterItem[]
}

function convertToWebcast(entries: string[]): WatchLaterResponse {

  return {
    watchLater: entries.map((entry) => {
      const [channelId, webcastId] = entry.split('-')
      return {
        id: Number(webcastId),
        channel: {
          id: Number(channelId)
        }
      }
    })
  }
}

async function fetchWatchLater (hostUrl = ''): Promise<WatchLaterResponse> {

  const { data } = await fetchJSON('fetchWatchLater', `${hostUrl || process.env.HOST}/service/follow?object_type=watch_later`, { includeCredentials: true,
  headers: {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json',
  } })

  return !data || !data.id ? defaultState : convertToWebcast(data.id)

}

export default fetchWatchLater
